import { render, staticRenderFns } from "./PageCreateTest.vue?vue&type=template&id=5fc98e62&scoped=true&"
import script from "./PageCreateTest.vue?vue&type=script&lang=js&"
export * from "./PageCreateTest.vue?vue&type=script&lang=js&"
import style0 from "./PageCreateTest.vue?vue&type=style&index=0&id=5fc98e62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc98e62",
  null
  
)

export default component.exports